import { client } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';

export interface IClient {
  Items: client.Client[];
}

export function getClients({ url: { service: baseURL }, token }: IAPI) {
  return async function getClients(): Promise<IClient> {
    const url = new URL(`/auth/client`, baseURL);
    try {
      const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return await response.json();
    } catch {
      throw new Error('Failed to fetch clients');
    }
  };
}
